// extracted by mini-css-extract-plugin
module.exports = {"select":"accessSection_select__2HCMJ","tdSection":"accessSection_tdSection__2zrRQ"};